import { isNumber, isString } from "lodash";

export const maskFunctions = {
  thousandSeparator: (value?: string | number) => {
    if (isNumber(value)) {
      value = value.toString();
    }

    if (!isString(value)) {
      return "";
    }

    const match = value.match(/^(\d+)(.*)$/);
    if (!match) return value;

    const digits = match[1] ?? "";
    const rest = match[2] ?? "";

    const formattedDigits = digits.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

    return `${formattedDigits}${rest}`;
  },
  formatPhoneNumber: (phone: string) => {
    let digits = phone.replace(/\D/g, "");
    if (digits.length !== 10 && digits.length !== 12) return phone;
    if (digits.length === 10) digits = "38" + digits;
    return `+${digits.slice(0, 2)} (${digits.slice(2, 5)}) ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10)}`;
  },
  uppercase: (value: string) => value?.toUpperCase(),
  numberPlate: (value: string) =>
    value.replace(/^([A-ZА-ЯІЇЄҐ]{2})(\d{4})([A-ZА-ЯІЇЄҐ]{2})$/i, "$1 $2 $3"),
};

const MASK_TRANSFORM_MAP = {
  thousandSeparator: maskFunctions.thousandSeparator,
  uppercase: maskFunctions.uppercase,
} as Record<string, <T>(value: T | undefined) => string>;

export const prepareValueByMask = <T>(value: T, mask: string | undefined) => {
  if (!mask) return value;

  const maskFunction = MASK_TRANSFORM_MAP[mask];

  if (maskFunction) return maskFunction(value);

  return value;
};

export const maskFieldProps = {
  thousandSeparator: {
    mask: Number,
    thousandsSeparator: " ",
  },
  passportSerie: {
    mask: "AA 000000",
    placeholder: "AA 000000",
    skipInvalid: false,
    blocks: {
      A: {
        mask: "a",
        prepareChar: (input: string) => input.toUpperCase(),
      },
      0: {
        mask: "0",
      },
    },
  },
  uppercase: {
    mask: /^.*$/,
    prepareChar: (input: string) => input.toUpperCase(),
  },
};

export type MasksKeysType = "thousandSeparator";
